import { render, staticRenderFns } from "./enLecturePage.vue?vue&type=template&id=543dc1f7&scoped=true&"
import script from "./enLecturePage.vue?vue&type=script&lang=js&"
export * from "./enLecturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543dc1f7",
  null
  
)

export default component.exports